class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.focusHandler = this.onFocusOut.bind(this);
    this.toggleHandler = this.onToggle.bind(this);

    this.mainDetailsToggle.addEventListener('focusout', this.focusHandler);
    this.mainDetailsToggle.addEventListener('toggle', this.toggleHandler);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.timeout = null;

    this.mainDetailsToggle.removeEventListener('toggle', this.toggleHandler);

    this.toggleHandler = this.onToggle.bind(this);
    this.mouseoverHandler = this.onMouseover.bind(this);
    this.mouseoutHandler = this.onMouseout.bind(this);

    this.mql = window.matchMedia('(hover: hover)');

    this.updateHandlers(this.mql.matches)

    this.mql.onchange = (e) => {
      this.updateHandlers(e.matches);
    }
  }

  updateHandlers(canHover) {
    if (canHover) {
      this.mainDetailsToggle.removeEventListener('focusout', this.focusHandler);
      this.mainDetailsToggle.removeEventListener('toggle', this.toggleHandler);

      this.mainDetailsToggle.addEventListener('mouseover', this.mouseoverHandler);
      this.mainDetailsToggle.addEventListener('mouseout', this.mouseoutHandler);
    } else {
      let link =  this.mainDetailsToggle.querySelector('.list-menu__toplink');
      if (!link) return;
      lilink.addEventListener('click', (e) => {
          e.preventDefault();
          this.onToggle();
          if (this.mainDetailsToggle.hasAttribute('open')) {
              return this.onMouseout();
          }
          this.onMouseover();

          return false;
      });
      this.mainDetailsToggle.addEventListener('focusout', this.focusHandler);
      this.mainDetailsToggle.addEventListener('toggle', this.toggleHandler);

      this.mainDetailsToggle.removeEventListener('mouseover', this.mouseoverHandler);
      this.mainDetailsToggle.removeEventListener('mouseout', this.mouseoutHandler);
    }
  }

  onMouseover() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    const siblings = document.querySelectorAll('header-menu details[open]');
    if (siblings.length)
      siblings.forEach(sibling => sibling.removeAttribute('open'));
    this.mainDetailsToggle.setAttribute('open', true);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach(animation => animation.play());
  }

  onMouseout() {
    this.timeout = setTimeout(() => {
      this.close()
      if (!this.animations) this.animations = this.content.getAnimations();
      this.animations.forEach(animation => animation.cancel());
    }, 200)
  }

  onToggle() {

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
